import { render, staticRenderFns } from "./PlaylistDesigner.vue?vue&type=template&id=a508245c"
import script from "./PlaylistDesigner.vue?vue&type=script&lang=js"
export * from "./PlaylistDesigner.vue?vue&type=script&lang=js"
import style0 from "./PlaylistDesigner.vue?vue&type=style&index=0&id=a508245c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports